import React, { useEffect, useState, useRef } from 'react';
import { Reorder } from 'framer-motion';
import { QuestionRendererProps } from './types';
import { GripVertical } from 'lucide-react';
import { LatexRenderer } from '../../ui/LatexRenderer';
export function OrderingRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const config = question.interactiveConfig || {};
  const items = config.items || [];
  const prevValidateRef = useRef(false);
  // State stores the current order of items (objects with id and content)
  const [order, setOrder] = useState(items.map((item: string, index: number) => ({
    id: index,
    content: item
  })));
  // Reset state when question changes
  useEffect(() => {
    setOrder(items.map((item: string, index: number) => ({
      id: index,
      content: item
    })));
    prevValidateRef.current = false;
  }, [question.id, items]);
  // Reset validation flag when shouldValidate becomes false
  useEffect(() => {
    if (!shouldValidate) {
      prevValidateRef.current = false;
    }
  }, [shouldValidate]);
  useEffect(() => {
    // Always ready since there is always an order
    onReadyChange?.(true);
  }, [onReadyChange]);
  // Rising-edge detection for shouldValidate
  useEffect(() => {
    if (shouldValidate && !prevValidateRef.current) {
      prevValidateRef.current = true;
      // Return comma-separated indices representing the current order
      const indices = order.map((item: any) => item.id).join(',');
      onAnswer(indices);
    }
  }, [shouldValidate, order, onAnswer]);
  return <div className="w-full max-w-lg mx-auto" data-id="element-4825">
      <p className="text-center text-slate-500 mb-4 text-sm font-medium" data-id="element-4826">
        Sleep de blokken in de juiste volgorde
      </p>

      <Reorder.Group axis="y" values={order} onReorder={setOrder} className="space-y-3" data-id="element-4827">

        {order.map((item: any) => <Reorder.Item key={item.id} value={item} className="bg-white border-2 border-slate-200 rounded-xl p-4 flex items-center gap-4 shadow-sm cursor-grab active:cursor-grabbing hover:border-indigo-300 transition-colors" data-id="element-4828">

            <GripVertical className="text-slate-400" data-id="element-4829" />
            <span className="text-lg font-medium text-slate-700 flex-1" data-id="element-4830">
              <LatexRenderer content={item.content} data-id="element-4831" />
            </span>
          </Reorder.Item>)}
      </Reorder.Group>
    </div>;
}